import logger from '../logger'

class PriceUtils {
  // Based on this gist, with some slight modifications: https://gist.github.com/jeffjohnson9046/9789876
  static format(price, options) {
    let returnVal
    const opts = options || {}

    if (typeof price === 'number') {
      returnVal = !price && opts.returnFree ? 'Free' : `$${PriceUtils.addCommas(price.toFixed(2))}`
    } else {
      logger(`PriceTools#format expects a number. ${typeof price} was given instead`, 'debug')()
      returnVal = price
    }

    return returnVal
  }

  static addCommas(inputVal) {
    return inputVal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  static roundTo(number) {
    return Math.round(number * 100) / 100
  }
}

export default PriceUtils
